module.exports = __webpack_public_path__ + "img/dataak.00d5833.svg";